import { select, selectAll, selectEntities } from './applicationSelectors';

export const selectProgramCohortEntities = selectEntities('programCohorts');
export const selectProgramCohorts = selectAll(selectProgramCohortEntities);
export const selectProgramCohort = select(selectProgramCohortEntities);
